import { Component, OnInit } from '@angular/core';
import { Project } from 'src/app/models/Project';
import { ApiService } from 'src/app/services/api.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { LangEnum } from 'src/app/models/LangEnum';
declare const $: any;

@Component({
  selector: 'app-projects-management',
  templateUrl: './projects-management.component.html',
  styleUrls: ['./projects-management.component.css']
})
export class ProjectsManagementComponent implements OnInit {

  projects = new Array<Project>();
  projectsIds: number[];
  selectedId: number;
  isDisabled = true;
  newProject = new Array<Project>();

  constructor(private service: ApiService) { }

  ngOnInit() {
    this.getProjects();
  }

  async getProjects() {
    $(".loader").addClass("flex-center");
    this.projects = await this.service.getProjects(false);
    
    // Recupero gli id dei clienti per ciclarli
    this.projectsIds = this.projects.sort((a, b) => {
      return  a.posizione - b.posizione;
    }).map(a => a.idProject);

    // Faccio un disctinct degli id per ciclare senza duplicati
    this.projectsIds = this.projectsIds.filter((thing, i, arr) => arr.findIndex(t => t === thing) === i);
    
    $(".loader").removeClass("flex-center");
  }
  getFlag(lang?: string) {
    return "./assets/img/" + lang + "_flag.svg"
  }
  getProjectById(id: number) {
    if (id)
    return this.projects.filter(a => a.idProject == id);
    else
      return this.newProject;
  }
  showModalEdit(id: number) {
    this.selectedId = id;
    $('.modal-project').modal('show');
  }
  openModalCreate() {
    this.selectedId = null;
    this.newProject = new Array<Project>();
    this.newProject[0] = new Project();
    this.newProject[1] = new Project();
    this.newProject[0].lang = LangEnum.EN;
    this.newProject[1].lang = LangEnum.IT;
    this.newProject[0].posizione = this.projectsIds.length + 1;
    this.newProject[1].posizione = this.projectsIds.length + 1;
    $('.modal-project').modal('show');
  }
  async update() {
    await this.service.updateProject(this.selectedId, this.getProjectById(this.selectedId));
    this.getProjects();
  }
  showModalDelete(id: number) {
    this.selectedId = id;
    $('.delete-project').modal('show');
  }
  async deleteProject() {
    await this.service.deleteProject(this.selectedId);
    this.getProjects();
  }
  showModalImage(id: number) {
    this.selectedId = id;
    $('.image-project').modal('show');
  }

  getImage(p: Project) {
    if (p.image)
      return '../../../assets/img/progetti/' + p.image;
    return '../../../assets/img/cog.jpg';
  }

  removeImage(id: number) {
    // TODO
  }

  async saveImage(id: number) {
    let file = document.getElementById('fileProject') as any;
    await this.service.uploadImageProject(id, file.files);
    this.getProjects();
  }
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    console.log('lista', this.projectsIds)
  }
  async saveOrdering() {
    this.isDisabled = true;
    await this.service.updateOrderingProject(this.projectsIds);
    this.getProjects();
  }
  save() {
    if (this.selectedId) {
      this.update();
    } else {
      this.create();
    }
  }
  async create() {
    await this.service.createProject(this.newProject);
    this.getProjects();
  }
}
